import React from 'react';

import { ProgramCriteriaForm } from 'components';

export const GenerateProgramReviewReportPage = () => {
    return <ProgramCriteriaForm />;
};
